// src/lib/weight.ts
import { getSupabase, currentUser } from "@/lib/supabase";

export interface WeightData {
  starting: number;
  current: number;
  goal: number;
}

/**
 * Load the user's weight data (starting, current, goal)
 */
export async function loadWeightData(): Promise<WeightData | null> {
  const supa = getSupabase();
  const u = await currentUser();

  if (!u) {
    console.warn("[weight] No authenticated user found");
    return null;
  }

  const { data, error } = await supa
    .from("client_goal_logs")
    .select("client_starting_weight, client_current_weight_in_kg, client_weight_goal_in_kg")
    .eq("user_id", u.id)
    .order("created_date", { ascending: false })
    .limit(1);

  if (error) {
    console.error("[weight] Error loading weight data:", error.message);
    return null;
  }

  if (!data || data.length === 0) {
    console.log("[weight] No weight data found for user");
    return null;
  }

  const row = data[0];

  // Validate that we have the required fields
  if (
    row.client_starting_weight == null ||
    row.client_current_weight_in_kg == null ||
    row.client_weight_goal_in_kg == null
  ) {
    console.warn("[weight] Weight data incomplete:", row);
    return null;
  }

  return {
    starting: row.client_starting_weight,
    current: row.client_current_weight_in_kg,
    goal: row.client_weight_goal_in_kg,
  };
}
